import React, { Fragment, useContext, useEffect, useState } from "react";
import RoleContext from "../ContextProvider/Index";
import DataTable from "react-data-table-component";
import { paginationComponentOptions } from "../../../Shared/Constants/DatatableConstants";
import { rolesListColums } from "../Data/RolesListColums";
import TableButtons from "../../../Shared/Components/TableButtons";
import { deleteConfirmationModal } from "../../../Shared/Components/DeleteConfrimationModal";
const DataTableRolesComponent = () => {
  const {
    fetchRoles,
    loading,
    searchTerm,
    roles,
    totalRows,
    rowsPerPage,
    currentPage,
    setCurrentPage,
    setRowsPerPage,
    setItem,
    modalTogle,
    deleteItem,
  } = useContext(RoleContext);
  const [colums, setColums] = useState([]);
  useEffect(() => {
    fetchRoles(currentPage, rowsPerPage);
  }, []);

  const handleDelete = (row) => {
    deleteConfirmationModal(row.id, deleteItem);
  };
  // Handle rows per page change
  const handleRowsPerPageChange = (newPerPage) => {
    setRowsPerPage(newPerPage);
    setCurrentPage(1); // Reset to first page
  };

  const handleEdit = async (row) => {
    let editObject = await roles.find((e) => e.id === row.id);

    console.log(editObject);

    setItem(editObject);
    modalTogle();
  };
  useEffect(() => {
    setColums([
      ...rolesListColums,
      {
        name: "Acciones",
        width: "200px",
        cell: (row) => (
          <TableButtons
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            row={row}
            entity={"role"}
          ></TableButtons>
        ),
        ignoreRowClick: true, // Prevent action buttons from triggering row selection
        allowOverflow: true, // Prevent layout overflow issues
        button: true, // Indicate that it's a button column
      },
    ]);
  }, [roles]);

  useEffect(() => {
    fetchRoles(currentPage, rowsPerPage);
  }, [currentPage, searchTerm]);

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  return (
    <Fragment>
      <DataTable
        data={roles}
        columns={colums}
        striped={true}
        center={true}
        pagination
        paginationServer // Enables server-side pagination
        paginationTotalRows={totalRows} // Pass total rows to DataTable
        paginationComponentOptions={paginationComponentOptions}
        paginationDefaultPage={currentPage} // Default current page
        paginationPerPage={rowsPerPage} // Rows per page
        onChangePage={handlePageChange} // Handle page change
        onChangeRowsPerPage={handleRowsPerPageChange} // Handle rows per page change
        progressPending={loading} // Show loading spinner
      />
    </Fragment>
  );
};

export default DataTableRolesComponent;
